import { FC } from 'react'

import { useRouter } from '@tanstack/react-router'
import { Link } from 'ui/components'

import { HistoryEntityType } from '../../enums'
import { getLinkByEntityType } from '../../utils/getLinkByEntityType'

import { SC } from './styles'

const ApplicationLink: FC<{ id: number; name: string }> = ({ id, name }) => {
  const router = useRouter()
  const to = getLinkByEntityType(HistoryEntityType.APPLICATION, id, router)

  return (
    <SC.Row>
      <span data-qa={`details-application-field-label`}>Application</span> -{' '}
      <Link to={to} data-qa={`details-application-field-value`}>
        {name}
      </Link>
    </SC.Row>
  )
}

export default ApplicationLink
